module.exports = __webpack_public_path__ + "static/media/fac icon.2916e1c3.png";